<script>
export default {
    props:{
        type:String,
        obj:{default:()=>{return {}}},
        status:[String,Boolean],
    },
    computed:{
        page(){ return this.$root.page },
        data(){
            if(this.type=="FlowStatus"){
                let status = this.status || this.obj.status
                if(!status) return {style:"warning",label:"Waiting"}
                if(this.obj.type=="SRF"&&status=='D') return {style:'warning',label:'Setup Facility'}
                return {
                    "A":{style:"success",label:"Approved"},
                    "C":{style:"success",label:"Confirmed"},
                    "R":{style:"danger",label:"Rejected"},
                }[status.toUpperCase()]
            }
            if(this.obj.ai_status){
                if(this.obj.ai_status=="DONE") return {style:"success",label:"Done"}
                if(this.obj.ai_status=="REJECTED") return {style:"danger",label:"Rejected"}
                if(this.obj.apc_id){
                    return {
                        "SIR": {style:"warning",label:"Submit Interview Result"},
                        "MCU": {style:"warning",label:"MCU Result"},
                        "OFFERING": {style:"info",label:"Offering"},
                        "SPD": {style:"info",label:"Submit Personal Data"},
                        "DONE": {style:"success",label:"Done"},
                        "REJECTED": {style:"danger",label:"Rejected"},
                        "REJECT": {style:"danger",label:"Rejected"},
                    }[this.obj.apc_flow_status]
                }
                var status = {
                    "SRF": {style:"warning",label:"Approval Services"},
                    "APA": {style:"warning",label:"Approval Admin"},
                    "PRFR": {style:"warning",label:"PRF Request"},
                    "SCD": {style:"success",label:"Approved"},
                    "SCS": {style:"warning",label:"Submit Candidate Selection"},
                    "MIS": {style:"info",label:"Manage Interview Session"},
                    "WFS": {style:"warning",label:"Working Facility Setup"},
                    "CFO": {style:"warning",label:"CFO Approval"},
                    "MNG": {style:"warning",label:"Manager Approval"},
                    "NMNG": {style:"warning",label:"New Manager Approval"},
                    "SPV": {style: "warning",label:"Requester Confirmation"},
                    "CDH": {style:"info",label:"CDH Approval"},
                    "ADC": {style: "warning", label: "Attachment Approval"}
                }[this.obj.ai_status.toUpperCase()]

                if(this.obj.ai_status=="NMNG"&&this.obj.ai_old_msg_id == this.obj.ai_msg_id) return {style:"warning",label:"Manager Approval"}

                if(status) return status
                if(this.obj.aal.aal_status){
                    return {
                        "A":{style:"success",label:"Approved"},
                        "R":{style:"danger",label:"Rejected"},
                    }[this.obj.aal.aal_status.toUpperCase()]
                }
            }
            if(this.type=='approvalStatus'){
                if (this.status == 'A') return {style:"success",label:"Approved"}
                else if (this.status == 'R') return {style:"danger",label:"Rejected"}
                else return {style:"warning",label:"Pending"}
            }
            if(this.type == 'onboardingChecklist'){
                if (this.status == 'O') return {style:"success",label:"Onboarding"}
                else if (this.status == 'M') return {style:"danger",label:"Movement"}
            }
            return this.status ?  {style:"success",label:"Active"} : {style:"warning",label:"Inactive"}
        }
    }
}
</script>

<template>
    <label :class="'label label-'+(data||{}).style">{{(data||{}).label}}</label>
</template>